export default "__VITE_PUBLIC_ASSET__b0ae594e__"